import React, { useRef, useState } from 'react';
import { Redirect } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

import AuthWelcome from './AuthWelcome';
import './LoginRegistration.css';
import bufflLogo from '../../assets/img/buffl.svg';

import getQueryStringParams from '../../helpers/getQueryStringParams';

const RegistrationForm = props => {
  const {
    fields,
    isAuthenticated,
    isProcessing,
    isCompleted,
    onChange,
    onSubmit,
    errors,
    onLoginAfterRegister,
    location: { search }
  } = props;

  const [passwordChecks, setPasswordChecks] = useState({
    length: false,
    uppercase: false,
    number: false
  });
  const isPasswordEntered = fields.password.value.length > 0;
  const handlePasswordValidation = password => {
    setPasswordChecks({
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      number: /\d/.test(password)
    });
  };
  const matchedConditions = Object.values(passwordChecks).filter(Boolean)
    .length;

  const passwordScore = matchedConditions * 33.33;
  const getProgressColor = () => {
    if (matchedConditions === 1) return 'red';
    if (matchedConditions === 2) return 'orange';
    if (matchedConditions === 3) return 'green';
    return 'transparent';
  };
  const reCaptchaRef = useRef(null);

  const queryParameters = getQueryStringParams(search);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  if (isCompleted) {
    if (
      fields &&
      fields.email &&
      fields.password &&
      fields.email.value &&
      fields.password.value
    ) {
      onLoginAfterRegister(
        fields.email.value,
        fields.password.value,
        queryParameters.token
      );
    } else {
      return <Redirect to="/auth/login" />;
    }
  }

  const onRegistrationFormSubmit = async ev => {
    ev.preventDefault();
    ev.stopPropagation();

    try {
      const reCaptchaValue = await reCaptchaRef.current.executeAsync();
      if (reCaptchaValue) {
        onSubmit(
          ev,
          fields.email.value,
          fields.password.value,
          fields.password2.value,
          fields.betaKey.value,
          fields.company.value,
          fields.telephone.value,
          fields.firstname.value,
          fields.lastname.value,
          fields.howDidYouLearnAboutBuffl.value
        );
      }
    } finally {
      if (reCaptchaRef.current && reCaptchaRef.current.reset) {
        reCaptchaRef.current.reset();
      }
    }
  };

  return (
    <div className="right-container registration-page">
      <AuthWelcome customClass="registration-page" />
      <div className="form-container registration-page">
        <form onSubmit={onRegistrationFormSubmit}>
          <img className="buffl-logo" src={bufflLogo} alt="Buffl logo" />
          <div className="form-container-title">Sign Up</div>
          <input
            type="text"
            value={fields.email.value}
            onChange={onChange('email')}
            placeholder="Email"
            className="client-registration-email-input"
          />
          <input
            type="password"
            value={fields.password.value}
            onChange={e => {
              onChange('password')(e);
              handlePasswordValidation(e.target.value);
            }}
            placeholder="Password"
            className="client-registration-password-input"
          />
          {isPasswordEntered && (
            <>
              <div className="password-progress">
                <div
                  className="password-progress-bar"
                  style={{
                    width: `${passwordScore}%`,
                    backgroundColor: getProgressColor(),
                    transition: 'all 0.3s ease'
                  }}
                />
              </div>

              <ul className="password-checklist">
                <li
                  style={{ color: passwordChecks.length ? 'green' : '#797575' }}
                >
                  At least 8 characters
                </li>
                <li
                  style={{
                    color: passwordChecks.uppercase ? 'green' : '#797575'
                  }}
                >
                  One uppercase letter
                </li>
                <li
                  style={{ color: passwordChecks.number ? 'green' : '#797575' }}
                >
                  One number
                </li>
              </ul>
            </>
          )}
          <input
            type="password"
            value={fields.password2.value}
            onChange={onChange('password2')}
            placeholder="Repeat password"
            className="client-registration-repeatpassword-input"
          />

          <input
            type="text"
            value={fields.company.value}
            onChange={onChange('company')}
            placeholder="Company"
            className="client-registration-company-input"
          />
          <input
            type="text"
            value={fields.telephone.value}
            onChange={onChange('telephone')}
            placeholder="Telephone"
            className="client-registration-telephone-input"
          />
          <input
            type="text"
            value={fields.firstname.value}
            onChange={onChange('firstname')}
            placeholder="Firstname"
            className="client-registration-firstname-input"
          />
          <input
            type="text"
            value={fields.lastname.value}
            onChange={onChange('lastname')}
            placeholder="Lastname"
            className="client-registration-lastname-input"
          />
          <textarea
            value={fields.howDidYouLearnAboutBuffl.value}
            onChange={onChange('howDidYouLearnAboutBuffl')}
            placeholder="How did you learn about BUFFL?"
            className="client-registration-howDidYouLearnAboutBuffl-input"
          />
          <ReCAPTCHA
            ref={reCaptchaRef}
            size="invisible"
            sitekey={
              process.env.NODE_ENV === 'development'
                ? '6Lc2yJwdAAAAANzmqQGquqx41k4l1jxlMgJIrS1P'
                : '6LfmGpwdAAAAANUlNgjng8mWe__WFz5e7fDXSxLe'
            }
          />
          {errors && errors[0] && !isProcessing ? (
            <div className="error-message">{errors[0].detail}</div>
          ) : null}
          {!isProcessing ? (
            <button type="submit" className="button client-registration-button">
              Register
            </button>
          ) : (
            <div className="button-loading">
              <div />
              <div />
              <div />
              <div />
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default RegistrationForm;
